export function getHeight(element) 
{
    element.style.display = 'block';
	const height = element.scrollHeight + 'px';	
	element.style.display = '';
	return height;
}

export function showElement(element) 
{
    element.previousElementSibling.setAttribute('aria-expanded', true);
    element.previousElementSibling.classList.add('active');
    const height = getHeight(element);
    element.classList.add('show');
    element.style.height = height;
}

export function hideElement(element) 
{
    element.previousElementSibling.setAttribute('aria-expanded', false);
    element.previousElementSibling.classList.remove('active');
    element.style.height = getHeight(element);
    
    setTimeout(function() {
        element.style.height = '0';
    }, 1);
    
    setTimeout(function() {
        element.classList.remove('show');
    }, 300); 
}

export function toggleElement(element)
{
    if (element.classList.contains('show')) {
		hideElement(element);
		return;
	}
	
	showElement(element);
}